import React from 'react'
import '../Project.css';
import { Parallax } from 'react-parallax';
import Image1 from '../../Gemco-Website-Images/projects/Zaabel_Empower_DCP.webp';

const Project_one = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Za'abeel District Cooling Plant</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>A new-build district cooling facility serving the Za'abeel precinct, providing centrally generated chilled water to high-density
                urban development across one of Dubai's key commercial and government districts.</p>
              <p>MAIN CONTRACTOR : -</p>
              <p>MEP CONTRACTOR : AGE</p>
              <p>GEMCO SCOPE OF WORKS : Full CHW pipework and electrical installations — complete MEP package</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_one